// extracted by mini-css-extract-plugin
export default {"input":"styles_input__kLvEH","button":"styles_button__ZzC0N","spin":"styles_spin__2k4Hu","link":"styles_link__8E2B2"};